/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ServicedeskChannelsEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const servicedeskChannelsEntryPoint: EntryPoint<ServicedeskChannelsEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<ServicedeskChannelsEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-channels", jiraSpaEntry: "async-servicedesk-channels" */ './ChannelsAppLayout.tsx',
		),
		getPreloadProps: () => ({
			queries: {},
			entryPoints: {},
			extraProps: {},
		}),
	});
